import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { WithTheme } from "src/styles/createStyledComponentsTheme";
import styled, { withTheme } from "styled-components";
import Heart from "src/components/icons/Heart";
import Indicator from "src/components/icons/Indicator";
import { ApplicationStore } from "src/store";
import { clearDealerChanges as clearDealerChangesAction } from "src/store/actions/deal";
import { DealerChangesState } from "src/store/reducers/dealerChanges";
import "./BannerNotification.scss";

const Banner = styled("div")`
    background-color: ${(props) => props.theme.palette.primary.main};
`;

const mapStateToProps = ({ dealerChanges }: ApplicationStore) => ({
    dealerChanges,
});

const mapDispatchToProps = {
    clearDealerChanges: clearDealerChangesAction,
};

interface BannerNotificationProps {
    clearDealerChanges: () => any;
    dealerChanges: DealerChangesState;
}

const BannerNotification = ({
    clearDealerChanges,
    dealerChanges: { changed, added },
    theme: {
        palette: { common },
    },
}: BannerNotificationProps & WithTheme) => {
    const [lastAdded, setLastAdded] = useState<any>(null);
    const [slideClass, setSlideClass] = useState("slideUp");
    const isLastVehicleJustAdded = useCallback(() => added.length > 0 && added[added.length - 1] !== lastAdded, [
        added,
        lastAdded,
    ]);
    const { t } = useTranslation();
    const getMessage = useCallback(
        () =>
            isLastVehicleJustAdded() ? (
                <>
                    <Heart className="banner-icons" />
                    {t("MyGarage.BannerNotification.dealerAddedMessage")}
                </>
            ) : (
                <>
                    <Indicator stroke={common.white} className="banner-icons" />
                    {t("MyGarage.BannerNotification.dealerChangedMessage")}
                </>
            ),
        [common, isLastVehicleJustAdded, t]
    );
    const [message, setMessage] = useState(getMessage());

    const handleOnMouseEnter = () => {
        clearDealerChanges();
        if (isLastVehicleJustAdded()) {
            setLastAdded(added[added.length - 1]);
        }
    };

    useEffect(() => {
        if (!changed.length) {
            setSlideClass("slideUp");
        }

        if (isLastVehicleJustAdded() || changed.length) {
            setMessage(getMessage());
            setSlideClass("slideDown");
        }
    }, [isLastVehicleJustAdded, changed, getMessage]);

    return (
        <Banner className={`banner-notification ${slideClass}`} onMouseEnter={handleOnMouseEnter}>
            {message}
        </Banner>
    );
};

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(BannerNotification));
